<div
  class="flex items-center justify-between full-width px-4"
  [ngStyle]="{ 'background-image': headerGradient() }"
>
  <!-- Header left -->
  <h3 class="font-bold text-xl">
    <ng-container *ngTemplateOutlet="headerTemplate()" />
  </h3>

  <div>
    <ng-container *ngTemplateOutlet="actionsTemplate()" />
  </div>
</div>
